export const getEnvironmentBackgroundClass = (environment: string | undefined): string => {
  const normalizedEnvironment = (environment ?? '').trim().toLowerCase()

  if (normalizedEnvironment === 'development') {
    return 'developmentBg'
  }

  if (normalizedEnvironment === 'staging') {
    return 'stagingBg'
  }

  return ''
}
